import { createIconComponent } from '../createIconComponent';
import { createIconFromSvg } from '../createIconFromSvg';

export const User = createIconComponent(
  createIconFromSvg({
    tag: 'svg',
    attr: {
      viewBox: '0 0 25 25',
      fill: 'none',
    },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M7.19357 14.8671C5.00809 16.2178 3.3892 18.5357 3.15459 21.8143C3.12174 22.2733 3.49998 22.6476 3.96022 22.6476L20.6015 22.6476C21.0618 22.6476 21.44 22.2733 21.4076 21.8142C21.1763 18.5304 19.5769 16.2177 17.4123 14.8697C16.9756 14.5977 16.4295 14.6007 15.9651 14.8221L13.0162 16.2282C12.562 16.4448 12.0343 16.4446 11.5803 16.2276L8.6392 14.8222C8.17567 14.6007 7.63058 14.597 7.19357 14.8671Z',
          stroke: 'currentColor',
          strokeWidth: '1.8',
        },
        child: [],
      },
      {
        tag: 'circle',
        attr: {
          cx: '12.2889',
          cy: '6.80066',
          r: '3.70065',
          stroke: 'currentColor',
          strokeWidth: '1.8',
        },
        child: [],
      },
    ],
  })
);
